const API_URL = process.env.REACT_APP_API_URL

export const CSRF_COOKE_URL = `${API_URL}/auth/csrf-cookie`

export const LOGIN_URL = `${API_URL}/auth/login`
export const LOGOUT_URL = `${API_URL}/auth/logout`
export const REGISTER_URL = `${API_URL}/auth/register`
export const GET_LOGGED_USER_INFOS = `${API_URL}/auth/me`
export const GET_LOGGED_USER_ACCOUNTS = `${API_URL}/auth/me/account`
export const DESTROY_USER_ACCOUNT_URL = `${API_URL}/auth/me/destroy`
export const RESET_PASSWORD_URL = `${API_URL}/auth/reset-password`
export const FORGOT_PASSWORD_URL = `${API_URL}/auth/forgot-password`
export const EMAIL_RESEND_URL = `${API_URL}/auth/email/resend`
export const EMAIL_VERIFY_URL = `${API_URL}/auth/email/verify`
export const IDENTITY_VERIFICATION_GLEAP_URL = `${API_URL}/auth/identity-verification/gleap`
export const INDUSTRIES_URL = `${API_URL}/industries`

export const PROFILE_URL = `${API_URL}/profiles`
export const USER_URL = `${API_URL}/users`
export const ANSWER_URL = `${API_URL}/answers`
export const AUTOMATION_URL = `${API_URL}/automations`
export const CONTACT_URL = `${API_URL}/contacts`
export const ANALYTICS_URL = `${API_URL}/analytics`
export const ACTIVITIES_URL = `${API_URL}/activities`
